export default __webpack_public_path__ + "static/iskustvo-a6d37a47b34ff72c0713f37cb685a27b.jpg";